import { createSlice } from '@reduxjs/toolkit';
import { sliceNames } from './constants';

export enum ActivePopupName {
  DUPLICATE_ITEMS = 'duplicateWithItemsPopup',
  MERGE_CONFIRMATION = 'mergeConfirmationPopup',
  PARENT_STATUS_CHANGE = 'parentStatusChangePopup',
  SR_TO_INCIDENT_STATUS_CHANGE = 'srToIncidentStatusChangePopup',
  UNCHANGED_CHILD_STATUS = 'unchangedChildStatusPopup',
}

export type ActivePopup = {
  id: number;
  name: ActivePopupName;
};

type ActivePopupsState = {
  activePopups: ActivePopup[];
};

const initialState: ActivePopupsState = {
  activePopups: [],
};

export const activePopupsReducer = createSlice({
  name: sliceNames.activePopupsSliceName,
  initialState,
  reducers: {
    setPopups: (state, action) => {
      state.activePopups = action.payload;
    },
  },
});

export const { setPopups } = activePopupsReducer.actions;

export const activePopupsSliceName = activePopupsReducer.name;

type AllState = {
  [activePopupsSliceName]: ActivePopupsState;
};

export const selectActivePopups = (allState: AllState): ActivePopup[] => allState[activePopupsSliceName].activePopups;
export const selectIsPopupActive =
  (popupName: ActivePopupName) =>
  (allState: AllState): boolean => {
    const activePopups = selectActivePopups(allState);
    if (!activePopups) return false;
    return activePopups?.some((popup) => popup.name === popupName);
  };
export default activePopupsReducer.reducer;
